/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useMemo, useState } from "react";
import { Modal, Label } from "flowbite-react";
import { HiMiniCalendarDays } from "react-icons/hi2";
import ReactSelect from "react-select";
import DatePicker from "react-datepicker";
import { TableFiltersState, inputStyles } from "../TableFilters";
import { useCompanyStore } from "../../../../states/store/Company";
import "../TableFilters.scss";
import "../Calendar.scss";
import "./AdvancedFilters.scss";
import { getPartnersFiltered } from "../../../../services/partners.api";
import * as XLSX from "xlsx";
import { useToastContext } from "../../toast/toast.context";

// eslint-disable-next-line react-refresh/only-export-components
export enum FleetManagementGroup {
  LOCAVIBE_GROUP = "locavibe_group",
  PARTNERS_ONLY = "partners_only",
}

type AdvancedFiltersState = {
  search: string;
  status: string[];
  orderBy: string | undefined;
  togglePopup?: () => void;
  itemsPerPageData?: { value: string; label: string };
  insuranceStatusOptionsData?: { value: string; label: string };
  isPopupOpen: boolean;
  technicalConsultant?: { value: string; label: string }[];
  partnerData?: { value: string; label: string }[];
  onSearch: (data: TableFiltersState) => void;
  entity?: string;
  receiveAdvancedFiltersData: (newFilters: TableFiltersState) => void;
  advancedFiltersData?: TableFiltersState;
  tableData: Record<string, unknown>[];
  selectDays: number;
  setSelectDays: (value: number) => void;
  userName?: string;
  isUserConsultant?: boolean;
  initialStartDate?: Date | null;
  initialEndDate?: Date | null;
};

export function AdvancedFilters(props: AdvancedFiltersState) {
  const insuranceStatusOptions = useMemo(
    () => [
      { label: "Selecione...", value: "" },
      { label: "Protegido", value: "protected" },
      { label: "Não protegido", value: "unprotected" },
    ],
    []
  );
  const gravityOptions = useMemo(
    () => [
      { label: "Leve", value: "LIGHT" },
      { label: "Média", value: "MEDIUM" },
      { label: "Grave", value: "SEVERE" },
      { label: "Gravíssima", value: "VERY_SEVERE" },
    ],
    []
  );
  const itemsPerPageOptions = useMemo(
    () => [
      { label: "10", value: "10" },
      { label: "20", value: "20" },
      { label: "50", value: "50" },
      { label: "100", value: "100" },
      { label: "200", value: "200" },
      { label: "500", value: "500" },
      { label: "1000", value: "1000" },
      { label: "Completo", value: "2000" },
    ],
    []
  );
  const [gravidade, setGravidade] = useState(
    props.advancedFiltersData?.gravity
  );
  const [filterMyLeads, setFilterMyLeads] = useState(
    props.advancedFiltersData?.filterMyLeads !== undefined
      ? props.advancedFiltersData.filterMyLeads
      : props.isUserConsultant
  );
  const [fleetManagementGroup, setFleetManagementGroup] =
    useState<FleetManagementGroup | null>(null);

  const [startDate, setStartDate] = useState<Date | null>(
    props.initialStartDate || null
  );
  const [endDate, setEndDate] = useState<Date | null>(
    props.initialEndDate || null
  );

  const [isLoading, setIsLoading] = useState(false);
  const [startDateAtualizadoEm, setStartDateAtualizadoEm] =
    useState<Date | null>(null);
  const [endDateAtualizadoEm, setEndDateAtualizadoEm] = useState<Date | null>(
    null
  );
  const [startDateTrafficFine, setStartDateTrafficFine] = useState<Date | null>(
    null
  );
  const [endDateTrafficFine, setEndDateTrafficFine] = useState<Date | null>(
    null
  );
  const [startDueDateTrafficFine, setStartDueDateTrafficFine] =
    useState<Date | null>(null);
  const [endDueDateTrafficFine, setEndDueDateTrafficFine] =
    useState<Date | null>(null);
  const [startDueDateScheduleMaintenance, setStartDueDateScheduleMaintenance] =
    useState<Date | null>(null);
  const [endDueDateScheduleMaintenance, setEndDueDateScheduleMaintenance] =
    useState<Date | null>(null);
  const [technicalConsultantData, setTechnicalConsultantData] = useState(
    props.advancedFiltersData?.technicalConsultantData
  );

  const [partnerCompanyName, setPartnerCompanyName] = useState<
    Array<{ value: string; label: string }>
  >(
    props.advancedFiltersData?.partnerData
      ? Array.isArray(props.advancedFiltersData.partnerData)
        ? props.advancedFiltersData.partnerData
        : [props.advancedFiltersData.partnerData]
      : []
  );
  const [partnerDataOptions, setPartnerDataOptions] = useState<
    { value: string; label: string }[]
  >([]);
  const [paymentTrafficfine, setPaymentTrafficfine] = useState<string>("all");
  const [itemsPerPageData, setItemsPerPageData] = useState(
    props.advancedFiltersData?.itemsPerPageData
  );
  const [insuranceStatusOptionsData, setInsuranceStatusOptionsData] = useState(
    props.advancedFiltersData?.insuranceStatusOptionsData
  );
  const [exportExcel, setExportExcel] = useState(false);
  const { notifyInfo } = useToastContext();

  const advancedFilters = {
    search: props.search || "",
    filterMyLeads: props.isUserConsultant,
    status: props.status || "",
    orderBy: props.orderBy,
    filterColumn: "",

    startDate: props.advancedFiltersData?.startDate,
    endDate: props.advancedFiltersData?.endDate,
    startDateAtualizadoEm: props.advancedFiltersData?.startDateAtualizadoEm,
    endDateAtualizadoEm: props.advancedFiltersData?.endDateAtualizadoEm,
    startDateTrafficFine: props.advancedFiltersData?.startDateTrafficFine,
    endDateTrafficFine: props.advancedFiltersData?.endDateTrafficFine,
    startDueDateTrafficFine: props.advancedFiltersData?.startDueDateTrafficFine,
    endDueDateTrafficFine: props.advancedFiltersData?.endDueDateTrafficFine,
    startDueDateScheduleMaintenance:
      props.advancedFiltersData?.startDueDateScheduleMaintenance,
    endDueDateScheduleMaintenance:
      props.advancedFiltersData?.endDueDateScheduleMaintenance,
    itemsPerPage:
      props.advancedFiltersData?.itemsPerPageData?.value ||
      itemsPerPageOptions[0].value,
    itemsPerPageData: props.advancedFiltersData?.itemsPerPageData,
    insuranceStatusOptionsData:
      props.advancedFiltersData?.insuranceStatusOptionsData,
    technicalConsultant:
      props.advancedFiltersData?.technicalConsultantData?.label,
    technicalConsultantData: props.advancedFiltersData?.technicalConsultantData,
    partnerId: partnerCompanyName.map((p) => p.value),
    partnerData: partnerCompanyName,
    paymentTrafficfine: props.advancedFiltersData?.paymentTrafficfine,
    gravity: props.advancedFiltersData?.gravity,
  };

  const [filters, setFilters] = useState<TableFiltersState>(advancedFilters);

  const handleApplyFilters = () => {
    const newFilters = {
      ...filters,
      startDate: startDate,
      endDate: endDate,
      startDateAtualizadoEm: startDateAtualizadoEm,
      endDateAtualizadoEm: endDateAtualizadoEm,
      startDateTrafficFine: startDateTrafficFine,
      endDateTrafficFine: endDateTrafficFine,
      startDueDateTrafficFine: startDueDateTrafficFine,
      endDueDateTrafficFine: endDueDateTrafficFine,
      startDueDateScheduleMaintenance: startDueDateScheduleMaintenance,
      endDueDateScheduleMaintenance: endDueDateScheduleMaintenance,
      technicalConsultant: technicalConsultantData?.label,
      technicalConsultantData: technicalConsultantData,

      partnerId: partnerCompanyName.map((p) => p.value),
      partnerData: partnerCompanyName,

      itemsPerPage: itemsPerPageData?.value,
      itemsPerPageData: itemsPerPageData,
      selectDays: props.selectDays,
      paymentTrafficfine: paymentTrafficfine,
      gravity: gravidade,
      fleetManagementGroup: fleetManagementGroup,
      filterMyLeads: filterMyLeads,
      insuranceStatusOptionsData: insuranceStatusOptionsData,
    };
    setFilters(newFilters as TableFiltersState);
    props.onSearch(newFilters as TableFiltersState);
    props.receiveAdvancedFiltersData(newFilters as TableFiltersState);
  };

  function handleClearFilters() {
    const clearedFilters = {
      ...filters,
      startDate: null,
      endDate: null,
      startDateAtualizadoEm: null,
      endDateAtualizadoEm: null,
      startDateTrafficFine: null,
      endDateTrafficFine: null,
      startDueDateTrafficFine: null,
      endDueDateTrafficFine: null,
      startDueDateScheduleMaintenance: null,
      endDueDateScheduleMaintenance: null,
      technicalConsultant: undefined,
      technicalConsultantData: undefined,
      gravity: undefined,
      partnerId: "",
      partnerData: undefined,
      itemsPerPage: itemsPerPageOptions[0].value,
      itemsPerPageData: itemsPerPageOptions[0],
      insuranceStatusOptionsData: insuranceStatusOptions[0],
      filterMyLeads: props.isUserConsultant,
      paymentTrafficfine: null,
      fleetManagementGroup: null,
    };

    setTechnicalConsultantData(undefined);
    setPartnerCompanyName([]);
    setFleetManagementGroup(null);
    setGravidade(undefined);
    handleDateChange([null, null]);
    handleDateChangeAtualizadoEm([null, null]);
    handleDateChangeTrafficFine([null, null]);
    handleDateChangeDueDateTrafficFine([null, null]);
    handleItemsPerPageChange(itemsPerPageOptions[0]);
    handlePaymentTrafficfineChange("all");

    setFilterMyLeads(props.isUserConsultant);
    setFilters(clearedFilters);

    props.onSearch(clearedFilters);
    props.receiveAdvancedFiltersData(clearedFilters);
  }

  const handleDateChange = (dates: [Date | null, Date | null]) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };

  const handleDateChangeAtualizadoEm = (dates: [Date | null, Date | null]) => {
    const [start, end] = dates;
    setStartDateAtualizadoEm(start);
    setEndDateAtualizadoEm(end);
  };

  function handleGravidadeChange(option) {
    setGravidade(option ? option.value : undefined);
  }

  const handleDateChangeTrafficFine = (dates: [Date | null, Date | null]) => {
    const [start, end] = dates;
    setStartDateTrafficFine(start);
    setEndDateTrafficFine(end);
  };

  const handleDateChangeDueDateTrafficFine = (
    dates: [Date | null, Date | null]
  ) => {
    const [start, end] = dates;
    setStartDueDateTrafficFine(start);
    setEndDueDateTrafficFine(end);
  };
  const handleDateChangeDueDateScheduleMaintenance = (
    dates: [Date | null, Date | null]
  ) => {
    const [start, end] = dates;
    setStartDueDateScheduleMaintenance(start);
    setEndDueDateScheduleMaintenance(end);
  };

  function handleItemsPerPageChange(option) {
    setItemsPerPageData(option);
  }

  function handleinsuranceStatusOptions(option) {
    setInsuranceStatusOptionsData(option);
  }

  function handleTechnicalConsultant(option) {
    setTechnicalConsultantData(option || null);
  }

  function handlePartnerData(option) {
    setPartnerCompanyName(option || []);
  }

  function handlePaymentTrafficfineChange(option) {
    setPaymentTrafficfine(option.value || null);
  }

  const { filterMode, selectedCompanies, selectedUf } = useCompanyStore();

  const technicalConsultant = useMemo(() => {
    if (Array.isArray(props.technicalConsultant)) {
      return props.technicalConsultant.map(({ value, label }) => ({
        value,
        label,
      }));
    }
    return [];
  }, [props.technicalConsultant]);

  useEffect(() => {
    async function getPartner() {
      const result = await getPartnersFiltered();
      if (!result.ok) {
        return [];
      }

      const partnerInfo = result.data.map((partner) => ({
        value: partner._id || "",
        label: partner.companyName,
      }));

      setPartnerDataOptions(partnerInfo);
    }

    if (props.entity === "vehicles" || props.entity === "trafficfines") {
      getPartner();
    }
  }, [props.entity, filterMode, selectedCompanies, selectedUf]);

  useEffect(() => {
    if (props.advancedFiltersData?.startDate) {
      setStartDate(props.advancedFiltersData.startDate);
    }
    if (props.advancedFiltersData?.endDate) {
      setEndDate(props.advancedFiltersData.endDate);
    }
    if (props.advancedFiltersData?.startDateAtualizadoEm) {
      setStartDateAtualizadoEm(props.advancedFiltersData.startDateAtualizadoEm);
    }
    if (props.advancedFiltersData?.endDateAtualizadoEm) {
      setEndDateAtualizadoEm(props.advancedFiltersData.endDateAtualizadoEm);
    }
    if (props.advancedFiltersData?.startDateTrafficFine) {
      setStartDateTrafficFine(props.advancedFiltersData.startDateTrafficFine);
    }
    if (props.advancedFiltersData?.endDateTrafficFine) {
      setEndDateTrafficFine(props.advancedFiltersData.endDateTrafficFine);
    }
    if (props.advancedFiltersData?.startDueDateTrafficFine) {
      setStartDueDateTrafficFine(
        props.advancedFiltersData.startDueDateTrafficFine
      );
    }
    if (props.advancedFiltersData?.endDueDateTrafficFine) {
      setEndDueDateTrafficFine(props.advancedFiltersData.endDueDateTrafficFine);
    }
    if (props.advancedFiltersData?.startDueDateScheduleMaintenance) {
      setStartDueDateScheduleMaintenance(
        props.advancedFiltersData.startDueDateScheduleMaintenance
      );
    }
    if (props.advancedFiltersData?.endDueDateScheduleMaintenance) {
      setEndDueDateScheduleMaintenance(
        props.advancedFiltersData.endDueDateScheduleMaintenance
      );
    }
    if (props.advancedFiltersData?.paymentTrafficfine) {
      setPaymentTrafficfine(props.advancedFiltersData.paymentTrafficfine);
    }
    if (props.advancedFiltersData?.gravity) {
      setGravidade(props.advancedFiltersData.gravity);
    }
  }, [
    props.advancedFiltersData?.startDate,
    props.advancedFiltersData?.endDate,
    props.advancedFiltersData?.startDateAtualizadoEm,
    props.advancedFiltersData?.endDateAtualizadoEm,
    props.advancedFiltersData?.startDateTrafficFine,
    props.advancedFiltersData?.endDateTrafficFine,
    props.advancedFiltersData?.startDueDateTrafficFine,
    props.advancedFiltersData?.endDueDateTrafficFine,
    props.advancedFiltersData?.paymentTrafficfine,
    props.advancedFiltersData?.startDueDateScheduleMaintenance,
    props.advancedFiltersData?.endDueDateScheduleMaintenance,
    props.advancedFiltersData?.gravity,
  ]);

  useEffect(() => {
    if (props.advancedFiltersData?.fleetManagementGroup !== undefined) {
      setFleetManagementGroup(
        props.advancedFiltersData.fleetManagementGroup
          ? (props.advancedFiltersData
              .fleetManagementGroup as FleetManagementGroup)
          : null
      );
    }
  }, [props.advancedFiltersData?.fleetManagementGroup]);

  useEffect(() => {
    async function exportExcelData() {
      if (exportExcel) {
        setExportExcel(false);

        if (!props.tableData || props.tableData.length === 0) {
          notifyInfo("Não há dados para exportar");
          return;
        }

        setIsLoading(true);

        const exportData = props.tableData.map(
          ({
            _id,
            vehiclePreparing,
            partnerInfo,
            updatedAt,
            fineUpload,
            ...rest
          }) => rest
        );

        const ws = XLSX.utils.json_to_sheet(exportData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Dados");
        XLSX.writeFile(wb, `${props.entity}_data.xlsx`);

        setIsLoading(false);
      }
    }

    exportExcelData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [exportExcel, props.tableData, props.entity]);

  return (
    <Modal
      size="6xl"
      className="modal-style"
      onClose={props.togglePopup}
      show={props.isPopupOpen}
    >
      <Modal.Header>
        <h2 className="label">Filtros Avançados</h2>
      </Modal.Header>

      <Modal.Body className="modal-body-style">
        <div>
          <div className="advanced-filters-inside-container">
            <div className="advanced-filters-date-picker">
              {props.entity !== "maintenance-schedule" ? (
                <>
                  <div className="datepicker-style-div">
                    <Label value="Criados entre:" className="label" />
                    <DatePicker
                      locale="pt-Br"
                      selectsRange
                      maxDate={new Date()}
                      startDate={
                        props.advancedFiltersData?.dateRange?.[0] ||
                        startDate ||
                        undefined
                      }
                      endDate={
                        props.advancedFiltersData?.dateRange?.[1] ||
                        endDate ||
                        undefined
                      }
                      onChange={handleDateChange}
                      className="date-picker"
                      placeholderText="Data Inicial e Final"
                      dateFormat="dd/MM/yyyy"
                      onFocus={(e) =>
                        ((e.target as HTMLInputElement).readOnly = true)
                      }
                      icon={<HiMiniCalendarDays />}
                      showIcon={!endDate}
                      toggleCalendarOnIconClick={true}
                      swapRange
                    />
                  </div>

                  <div className="datepicker-style-div">
                    <Label value="Atualizado entre:" className="label" />
                    <DatePicker
                      locale="pt-Br"
                      selectsRange
                      maxDate={new Date()}
                      startDate={
                        props.advancedFiltersData?.dateRangeAtualizadoEm?.[0] ||
                        startDateAtualizadoEm ||
                        undefined
                      }
                      endDate={
                        props.advancedFiltersData?.dateRangeAtualizadoEm?.[1] ||
                        endDateAtualizadoEm ||
                        undefined
                      }
                      onChange={handleDateChangeAtualizadoEm}
                      className="date-picker"
                      placeholderText="Data Inicial e Final"
                      dateFormat="dd/MM/yyyy"
                      onFocus={(e) =>
                        ((e.target as HTMLInputElement).readOnly = true)
                      }
                      icon={<HiMiniCalendarDays />}
                      showIcon={true}
                      toggleCalendarOnIconClick={true}
                      swapRange
                    />
                  </div>
                  {props.entity == "trafficfines" && (
                    <>
                      <div className="datepicker-style-div">
                        <Label value="Período de Multas" className="label" />
                        <DatePicker
                          locale="pt-Br"
                          selectsRange
                          maxDate={new Date()}
                          startDate={
                            props.advancedFiltersData
                              ?.dateRangeTrafficFine?.[0] ||
                            startDateTrafficFine ||
                            undefined
                          }
                          endDate={
                            props.advancedFiltersData
                              ?.dateRangeTrafficFine?.[1] ||
                            endDateTrafficFine ||
                            undefined
                          }
                          onChange={handleDateChangeTrafficFine}
                          className="date-picker"
                          placeholderText="Data Inicial e Final"
                          dateFormat="dd/MM/yyyy"
                          onFocus={(e) =>
                            ((e.target as HTMLInputElement).readOnly = true)
                          }
                          icon={<HiMiniCalendarDays />}
                          showIcon={true}
                          toggleCalendarOnIconClick={true}
                          swapRange
                        />
                      </div>
                      <div className="datepicker-style-div">
                        <Label value="Vencimento de Multas" className="label" />
                        <DatePicker
                          locale="pt-Br"
                          selectsRange
                          startDate={
                            props.advancedFiltersData
                              ?.dueDateRangeTrafficFine?.[0] ||
                            startDueDateTrafficFine ||
                            undefined
                          }
                          endDate={
                            props.advancedFiltersData
                              ?.dueDateRangeTrafficFine?.[1] ||
                            endDueDateTrafficFine ||
                            undefined
                          }
                          onChange={handleDateChangeDueDateTrafficFine}
                          className="date-picker"
                          placeholderText="Data Inicial e Final"
                          dateFormat="dd/MM/yyyy"
                          onFocus={(e) =>
                            ((e.target as HTMLInputElement).readOnly = true)
                          }
                          icon={<HiMiniCalendarDays />}
                          showIcon={true}
                          toggleCalendarOnIconClick={true}
                          swapRange
                        />
                      </div>

                      <div>
                        <Label
                          htmlFor="paymentTrafficfine"
                          value="Boleto Anexado"
                          className="label"
                        />
                        <ReactSelect
                          options={[
                            { value: "all", label: "Todos" },
                            { value: "true", label: "Sim" },
                            { value: "false", label: "Não" },
                          ]}
                          name="paymentTrafficfine"
                          onChange={handlePaymentTrafficfineChange}
                          isClearable={false}
                          value={
                            paymentTrafficfine
                              ? {
                                  value: paymentTrafficfine,
                                  label:
                                    paymentTrafficfine === "all"
                                      ? "Todos"
                                      : paymentTrafficfine === "true"
                                      ? "Sim"
                                      : "Não",
                                }
                              : { value: "all", label: "Todos" }
                          }
                          onFocus={(e) =>
                            ((e.target as HTMLInputElement).readOnly = true)
                          }
                        />
                      </div>
                    </>
                  )}
                </>
              ) : (
                <div className="datepicker-style-div">
                  <Label value="Agendados entre:" className="label" />
                  <DatePicker
                    locale="pt-Br"
                    selectsRange
                    startDate={
                      props.advancedFiltersData?.dateRange?.[0] ||
                      startDueDateScheduleMaintenance ||
                      undefined
                    }
                    endDate={
                      props.advancedFiltersData?.dateRange?.[1] ||
                      endDueDateScheduleMaintenance ||
                      undefined
                    }
                    onChange={handleDateChangeDueDateScheduleMaintenance}
                    className="date-picker"
                    placeholderText="Data Inicial e Final"
                    dateFormat="dd/MM/yyyy"
                    onFocus={(e) =>
                      ((e.target as HTMLInputElement).readOnly = true)
                    }
                    icon={<HiMiniCalendarDays />}
                    showIcon={!endDate}
                    toggleCalendarOnIconClick={true}
                    swapRange
                  />
                </div>
              )}
            </div>

            {props.entity !== "purchase-suggestion" && (
              <div>
                <Label
                  htmlFor="itensPerPage"
                  value="Linhas por página:"
                  className="label"
                />
                <ReactSelect
                  options={itemsPerPageOptions}
                  name="itemsPerPage"
                  styles={inputStyles}
                  onChange={handleItemsPerPageChange}
                  isClearable={false}
                  value={
                    itemsPerPageData
                      ? {
                          value: itemsPerPageData.value,
                          label: itemsPerPageData.label,
                        }
                      : itemsPerPageOptions[0]
                  }
                  onFocus={(e) =>
                    ((e.target as HTMLInputElement).readOnly = true)
                  }
                />
              </div>
            )}

            {props.entity === "vehicles" && (
              <div>
                <Label
                  htmlFor="insuranceStatus"
                  value="Proteção:"
                  className="label"
                />
                <ReactSelect
                  options={insuranceStatusOptions}
                  name="insuranceStatus"
                  styles={inputStyles}
                  onChange={handleinsuranceStatusOptions}
                  isClearable={false}
                  value={
                    insuranceStatusOptionsData
                      ? {
                          value: insuranceStatusOptionsData.value,
                          label: insuranceStatusOptionsData.label,
                        }
                      : insuranceStatusOptions[0]
                  }
                  onFocus={(e) =>
                    ((e.target as HTMLInputElement).readOnly = true)
                  }
                />
              </div>
            )}
          </div>

          <div className="w-full">
            {(props.entity === "renters" || props.entity === "leads") && (
              <div>
                <Label
                  htmlFor="selectTechnicalConsultant"
                  value="Consultor:"
                  className="label"
                />
                <ReactSelect
                  options={technicalConsultant}
                  name="technicalConsultant"
                  styles={inputStyles}
                  onChange={handleTechnicalConsultant}
                  placeholder="Consultor"
                  value={technicalConsultantData}
                />
              </div>
            )}
            {props.entity === "leads" && (
              <div className="mt-4">
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    className="h-5 w-5 rounded border-gray-300 text-red-600 focus:ring-red-500 disabled:opacity-50 disabled:cursor-not-allowed"
                    checked={filterMyLeads}
                    onChange={(e) => setFilterMyLeads(e.target.checked)}
                    disabled={!props.isUserConsultant}
                  />
                  <span
                    className={`label ${
                      !props.isUserConsultant ? "text-gray-400" : ""
                    }`}
                  >
                    Filtrar apenas minhas leads
                  </span>
                </label>
              </div>
            )}
            {props.entity == "trafficfines" && (
              <div className="mt-4">
                <div>
                  <Label
                    htmlFor="gravidade"
                    value="Gravidade"
                    className="label"
                  />
                  <ReactSelect
                    options={gravityOptions}
                    name="gravidade"
                    styles={inputStyles}
                    onChange={handleGravidadeChange}
                    isClearable={true}
                    placeholder="Selecione..."
                    value={
                      gravidade
                        ? gravityOptions.find((o) => o.value === gravidade)
                        : null
                    }
                  />
                </div>
              </div>
            )}
            {/* Parceiros */}
            {(props.entity === "vehicles" ||
              props.entity == "trafficfines") && (
              <div className="mt-4">
                <Label
                  htmlFor="selectPartnerData"
                  value="Parceiros:"
                  className="label"
                />
                <ReactSelect
                  options={partnerDataOptions}
                  name="partnerData"
                  styles={inputStyles}
                  onChange={handlePartnerData}
                  placeholder="Parceiros"
                  isMulti
                  value={partnerCompanyName}
                />
              </div>
            )}

            {props.entity == "trafficfines" && (
              <div className="mt-4 flex flex-row gap-4">
                {/* FleetManagementGroup Enum */}
                {(() => {
                  return (
                    <>
                      <label className="flex items-center gap-2 cursor-pointer">
                        <input
                          type="checkbox"
                          className="sr-only"
                          checked={
                            fleetManagementGroup ===
                            FleetManagementGroup.LOCAVIBE_GROUP
                          }
                          onChange={() => {
                            setFleetManagementGroup(
                              fleetManagementGroup ===
                                FleetManagementGroup.LOCAVIBE_GROUP
                                ? null
                                : FleetManagementGroup.LOCAVIBE_GROUP
                            );
                          }}
                        />
                        <div
                          className={`w-5 h-5 border-2 border-gray-400 rounded-md flex items-center justify-center transition-all duration-300 ${
                            fleetManagementGroup ===
                            FleetManagementGroup.LOCAVIBE_GROUP
                              ? "bg-orange-500 border-orange-500"
                              : "bg-white"
                          }`}
                        >
                          {fleetManagementGroup ===
                            FleetManagementGroup.LOCAVIBE_GROUP && (
                            <span className="text-white text-xs">✓</span>
                          )}
                        </div>
                        <span className="text-sm">Grupo Locavibe</span>
                      </label>

                      <label className="flex items-center gap-2 cursor-pointer">
                        <input
                          type="checkbox"
                          className="sr-only"
                          checked={
                            fleetManagementGroup ===
                            FleetManagementGroup.PARTNERS_ONLY
                          }
                          onChange={() => {
                            setFleetManagementGroup(
                              fleetManagementGroup ===
                                FleetManagementGroup.PARTNERS_ONLY
                                ? null
                                : FleetManagementGroup.PARTNERS_ONLY
                            );
                          }}
                        />
                        <div
                          className={`w-5 h-5 border-2 border-gray-400 rounded-md flex items-center justify-center transition-all duration-300 ${
                            fleetManagementGroup ===
                            FleetManagementGroup.PARTNERS_ONLY
                              ? "bg-orange-500 border-orange-500"
                              : "bg-white"
                          }`}
                        >
                          {fleetManagementGroup ===
                            FleetManagementGroup.PARTNERS_ONLY && (
                            <span className="text-white text-xs">✓</span>
                          )}
                        </div>
                        <span className="text-sm">Somente parceiros</span>
                      </label>
                    </>
                  );
                })()}
              </div>
            )}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="advanced-filter-modal-footer">
        <div className="advanced-filter-modal-footer-items">
          <button
            className="button-with-loader"
            onClick={() => setExportExcel(true)}
            disabled={isLoading}
          >
            {isLoading ? (
              <div className="loader flex justify-center items-center">
                <div className="bar"></div>
                <div className="bar"></div>
                <div className="bar"></div>
              </div>
            ) : (
              "Exportar para Excel"
            )}
          </button>
        </div>

        <div className="advanced-filter-modal-footer-items">
          <button
            className="filter-generic-button"
            onClick={() => {
              handleApplyFilters();
              if (props.togglePopup) {
                props.togglePopup();
              }
            }}
          >
            Aplicar filtros
          </button>
          <button
            className="filter-generic-button"
            onClick={handleClearFilters}
          >
            Limpar filtros
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default AdvancedFilters;
